import moment from 'moment'

export const formatOutOfStockDate = date => {
  return date
    ? moment(date).format('DD/MM/YYYY')
    : `Apagado\r\n indefinidamente`
}
